import processingMarkDeclareReducer from "./markDeclareReducer";

const processingMarkDeclareReducers = {
    processingMarkDeclare: processingMarkDeclareReducer
}

export default processingMarkDeclareReducers